import React from 'react';
import styles from './drawerContent.module.scss';
import IconClose from '@/assets/icons/icon-round-close.svg';
import { useTranslations } from 'next-intl';

const DrawerHeader = ({ closeButton }: { closeButton: () => void }) => {
  const t = useTranslations('General');
  return (
    <div className={styles.mobileClose}>
      <h3>{t('catalog-products')}</h3>
      <button
        type="button"
        className={styles.drawer__closeButton}
        onClick={closeButton}
      >
        <IconClose />
      </button>
    </div>
  );
};

export default DrawerHeader;
